import DrEventUploadLogs from './DrEventUploadLogs';

export default DrEventUploadLogs;
